class Fabrics {
    getDefaultFabricCode() {
        const fabric = _.first(QX7Rule.materialFabricGroups);
        let defaultFabric = null;

        if (fabric) {
            defaultFabric = fabric["Default Fabric"]
        }

        return defaultFabric;
    }

    getFabric(fabric_code) {
        return _.find(QX7Rule.fabrics, {fabric_code});
    }

    getDefaultFabricObject() {
        let fabric_code = this.getDefaultFabricCode();

        return _.find(QX7Rule.raw.fabrics, {fabric_code});
    }
}